import {
  IconButton,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ModuleItemBox } from '../FolderModule.styles';
import { useEffect, useState } from 'react';
import { theme } from '../../../../theme';
import { fetchFileModuleThunk } from '../../../../store/thunk/serviceModulesThunk';
import { useAppDispatch } from '../../../../hooks/StoreHooks';
import { FileServiceModule, ServiceModuleTypes } from '../../../../types/serviceModuleTypes';
import DefaultIcon from '../../../../components/common/DefaultIcon';
import { defaultIcon } from '../../ServiceModulesContainer';
import FileDialog from './FileDialog';

type Props = {
  id: number;
  name: string;
  type: string;
  fileUrl: string;
  filename: string;
  iconName: string;
  iconUrl: string | null;
  colorHex: string | null;
  onDelete: () => void;
  onEdit: () => void;
};

const FileCard = ({
  id,
  name,
  type,
  fileUrl,
  filename,
  iconName,
  colorHex,
  iconUrl,
  onEdit,
  onDelete,
}: Props) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [existingFileUrl, setExistingFileUrl] = useState<string | null>(null);
  const [needsReadReceipt, setNeedsReadReceipt] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchExistingFile = async () => {
      try {
        const result = await dispatch(fetchFileModuleThunk(id)).unwrap() as FileServiceModule;
        if (result.type === ServiceModuleTypes.File && result.downloadUrl) {
          setExistingFileUrl(result.downloadUrl);
        }
        setNeedsReadReceipt(result.needsReadReceipt)
      } catch (error) {
        console.error("Error fetching file:", error);
      }
    };
    fetchExistingFile();
  }, [dispatch, id]);

  const handleModuleClick = () => {
    setOpenDialog(true);
  };

  const handleEditClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEdit();
  };

  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDelete();
  };

  return (
    <>
      <ModuleItemBox onClick={handleModuleClick}>
        <DefaultIcon
          iconName={iconName ?? defaultIcon(type)}
          colorHex={colorHex ?? theme.palette.primary.main}
          iconUrl={iconUrl}
        />
        <Typography sx={{ flexGrow: 1, marginLeft: 2 }}>{name}</Typography>
        <IconButton onClick={handleEditClick}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={handleDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </ModuleItemBox>

      <FileDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        name={name}
        filename={filename}
        fileUrl={existingFileUrl}
        serviceModuleId={id}
        needsReadReceipt={needsReadReceipt}
      />
    </>
  );
};

export default FileCard;
